import { useEffect, useRef, useState } from 'react';
import { ClassroomMarkerOptions } from './ClassroomStudioControls';
import { classroomMarkerLabel, type ClassroomMarkerMode } from '../domain/classroom-marker-display';

/** Reuse the studio's ranges, including custom counts, in the classic toolbar. */
export function StudentPracticeMarkerControl({
  markerMode,
  customMarkerCount,
  onSelect,
  onCustomChange,
}: {
  readonly markerMode: ClassroomMarkerMode;
  readonly customMarkerCount: number;
  readonly onSelect: (mode: ClassroomMarkerMode, count?: number) => void;
  readonly onCustomChange: (count: number) => void;
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const close = () => {
    setOpen(false);
    buttonRef.current?.focus();
  };
  useEffect(() => {
    if (!open) return;
    const outside = (event: PointerEvent) => {
      if (event.target instanceof Node && !rootRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('pointerdown', outside);
    return () => document.removeEventListener('pointerdown', outside);
  }, [open]);
  return (
    <div
      className="student-practice-markers"
      ref={rootRef}
      onKeyDown={(event) => {
        event.stopPropagation();
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
        }
      }}
      onBlur={(event) => {
        if (
          event.relatedTarget instanceof Node &&
          !event.currentTarget.contains(event.relatedTarget)
        )
          setOpen(false);
      }}
    >
      <button
        ref={buttonRef}
        type="button"
        aria-expanded={open}
        title={`当前显示${classroomMarkerLabel(markerMode, customMarkerCount)}`}
        onClick={() => setOpen(!open)}
      >
        手数显示
      </button>
      {open ? (
        <ClassroomMarkerOptions
          presentation="list"
          markerMode={markerMode}
          customMarkerCount={customMarkerCount}
          onCustomChange={onCustomChange}
          onSelect={(mode, count) => {
            onSelect(mode, count);
            close();
          }}
        />
      ) : null}
    </div>
  );
}
